import TextFileExtensions from './text-file-extensions.constant';

const FileRegexps = {
  IMG: /\.(jpg|jpeg|png|webp)$/,
  READABLE: (() => new RegExp(`\\.(${Object.values(TextFileExtensions).join('|')})$`))(),
  NOT_READABLE: /\.(zip|rar|7z|tar|gz|tar\.gz|pdf|doc|docx|xls|xlsx|ppt|pptx|mkv|mp4|mp3|wav)$/,
};

export default FileRegexps;
